import React from "react";
import Header from "../components/header/header";
import DummyImage from "../../assets/img/dummy-img2.jpeg";
import IOS from "../../assets/img/ios-btn.png";
import Andriod from "../../assets/img/android-btn.png";
import Footer from "../components/footer/footer";
import virtualLogo from "../../assets/img/virtual-psych-logo.png";
import tick from "../../assets/img/tick.svg";
import "./CanIGetPrescription.scss";


const CanIGetPresciption = () => {
    return (
        <div className="can-i-get-prescription">
            <div className="can-i-get-prescription-header-about-doc">
                <Header />
            </div>
            <div class="top-banner small-banner whatissue-banner">
                <div class="container"></div>
            </div>
            <div id="section3">
                <section id="testimornial-area" >
                    <div className="container card">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service">
                                    <h2>Can I Get Prescription</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* footer */}
            <div className="footer">
                <Footer />
            </div>

        </div>
    );
};

export default CanIGetPresciption;